import { render, staticRenderFns } from "./AdditionalInformationTab.vue?vue&type=template&id=1fa1de2c&scoped=true&"
import script from "./AdditionalInformationTab.vue?vue&type=script&lang=js&"
export * from "./AdditionalInformationTab.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInformationTab.vue?vue&type=style&index=0&id=1fa1de2c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa1de2c",
  null
  
)

export default component.exports